import React, { createContext, useContext, ReactNode } from 'react';
import { useTenant } from '@/hooks/useTenant';
import type { PublicTenant } from '@/services/publicTenant.service';
import type { TenantConfig } from '@/types/tenant';

interface TenantContextValue {
 tenant: PublicTenant | null;
 config: TenantConfig | null;
 loading: boolean;
 error: string | null;
 refetch: () => Promise<void>;
}

const TenantContext = createContext<TenantContextValue | null>(null);

export function TenantProvider({ children }: { children: ReactNode }) {
 const value = useTenant();
 return (
 <TenantContext.Provider
 value={{
 tenant: value.tenant,
 config: value.config,
 loading: value.loading,
 error: value.error,
 refetch: value.refetch,
 }}
 >
 {children}
 </TenantContext.Provider>
 );
}

export function useTenantContext(): TenantContextValue {
 const ctx = useContext(TenantContext);
 if (!ctx) {
 throw new Error('useTenantContext must be used within TenantProvider');
 }
 return ctx;
}
